<template>
  <div>
    <div class="row">
      <div v-for="(card,index) in cards" :key="card.title">
        <div :class="{lightgrey: index % 2 === 0}" class="col s12">
          <div class="col s12 m10 l8 offset-m1 offset-l2">
            <h2 class="header">{{$t(card.title)}}</h2>
            <div class="card horizontal">
              <div class="card-image">
                <img :src="card.img.link" :alt="$t(card.img.alt)"/>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <p v-html="$t(card.desc)"></p>
                </div>
                <div class="card-action" :class="{hide: card.action === '' }"><p v-html="$t(card.action)"></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Java',
  data () {
    return {
      cards: [{
        title: 'java.bn.title',
        img: {link: 'static/img/bataille.jpg', alt: 'java.bn.alt.pict'},
        desc: 'java.bn.desc',
        action: 'java.bn.action'
      }, {
        title: 'java.edf.title',
        img: {link: 'static/img/appli_edf.png', alt: 'java.edf.alt.pict'},
        desc: 'java.edf.desc',
        action: ''
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Java.vue